import { PureComponent } from 'react'

export interface MetadataFilter {
  readonly fieldID: string
  readonly values: string[]
}

export interface MetadataFilterManagerChildProps {
  readonly metadataSelections: MetadataFilter[]
  readonly onMetadataOptionsToggle: (
    groupID: string,
    optionIDs: string[]
  ) => void
  readonly onClearMetadataSelections: () => void
}

interface Props {
  readonly children: (props: MetadataFilterManagerChildProps) => React.ReactNode
}

interface State {
  readonly metadataSelections: MetadataFilter[]
}

export class MetadataFilterManager extends PureComponent<Props, State> {
  public state: State = {
    metadataSelections: []
  }

  public render() {
    const { metadataSelections } = this.state
    const { children } = this.props

    return children({
      metadataSelections,
      onMetadataOptionsToggle: this.onMetadataOptionsToggle,
      onClearMetadataSelections: this.onClearMetadataSelections
    })
  }

  private onClearMetadataSelections = () => {
    this.setState({ metadataSelections: [] })
  }

  private onMetadataOptionsToggle = (groupID: string, optionIDs: string[]) => {
    this.setState(({ metadataSelections: prevMetadataSelections }) => {
      const groupIndex = prevMetadataSelections.findIndex(
        ({ fieldID }) => fieldID === groupID
      )

      if (groupIndex > -1) {
        const prevSelection = prevMetadataSelections[groupIndex]

        const updatedValues = optionIDs.reduce((acc, curr) => {
          const index = acc.indexOf(curr)
          if (index > -1) {
            return [...acc.slice(0, index), ...acc.slice(index + 1, acc.length)]
          }

          return [...acc, curr]
        }, prevSelection.values)

        return {
          metadataSelections:
            updatedValues.length > 0
              ? [
                  ...prevMetadataSelections.slice(0, groupIndex),
                  {
                    fieldID: groupID,
                    values: updatedValues
                  },
                  ...prevMetadataSelections.slice(
                    groupIndex + 1,
                    prevMetadataSelections.length
                  )
                ]
              : [
                  ...prevMetadataSelections.slice(0, groupIndex),
                  ...prevMetadataSelections.slice(
                    groupIndex + 1,
                    prevMetadataSelections.length
                  )
                ]
        }
      }

      return {
        metadataSelections: [
          ...prevMetadataSelections,
          { fieldID: groupID, values: optionIDs }
        ]
      }
    })
  }
}
